@if (isShown) {
  <div @snackTrigger class="snack-container">
    <app-alert-card
      data-testid="alert-component"
      [type]="type"
      [title]="title"
      [description]="message"
      [styleOption]="{ strip: true, iconCenterAlign: true }"
      [closeIcon]="true"
      [actionText]="actionText"
      [actionCallback]="actionCallback"
      (closeEvent)="isShown = false"
    ></app-alert-card>
  </div>
}
